document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-sb-mobile-menu]');
  const openButton = document.querySelector('[data-sb-menu-open]');
  const closeButtons = document.querySelectorAll('[data-sb-menu-close]');
  const header = document.querySelector('[data-sb-header]');
  const setHeaderState = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 30); };
  setHeaderState(); window.addEventListener('scroll', setHeaderState, { passive: true });
  if (!menu || !openButton) return;
  const setOpen = (open) => { menu.classList.toggle('is-open', open); menu.setAttribute('aria-hidden', String(!open)); openButton.setAttribute('aria-expanded', String(open)); document.body.classList.toggle('sb-body-menu-open', open); };
  openButton.addEventListener('click', () => setOpen(true));
  closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
});
